import { AuthenticatedUserProfile } from '@sparkai/shared-types'
import { isRunningOnCypress, isRunningOnPlaywright } from '@sparkai/utils'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import Axios from 'axios'
import { useEffect } from 'react'

import { AuthState, useAuthStore } from '../stores/authStore'

export const api = Axios.create({
  baseURL: `${window.location.origin.toString()}/`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
  },
  timeout: 15000,
})

export const AUTHENTICATED_USER_PROFILE_KEY = 'authenticated-user-profile'
const selectToken = (state: AuthState) => state.token

export function useFetchCurrentUserProfile(onProfileFetched: (data: AuthenticatedUserProfile) => void) {
  const queryClient = useQueryClient()
  const token = useAuthStore(selectToken)

  const { isError, data: profileData } = useQuery({
    queryKey: [AUTHENTICATED_USER_PROFILE_KEY],
    queryFn: async () => {
      const response = await api.get<AuthenticatedUserProfile>('int/app_user/mine', {
        headers: { Authorization: `Bearer ${token}` },
      })
      return response.data
    },
    enabled: !!token || isRunningOnCypress || isRunningOnPlaywright,
    refetchOnWindowFocus: false,
  })

  useEffect(() => {
    if (profileData) {
      onProfileFetched(profileData)
    }
  }, [profileData, onProfileFetched])

  useEffect(() => {
    if (!token) return
    queryClient.invalidateQueries({ queryKey: [AUTHENTICATED_USER_PROFILE_KEY] })
  }, [queryClient, token])

  return {
    isErrorFetchingProfile: isError,
  }
}
